export const getEnvironemnt = () => {
	const domain = window.location.hostname;
	if (domain.includes('uat') || domain.includes('localhost')) {
		return 'UAT';
	}
	return 'PROD';
};

export const getDomain = () => {
	const domain = window.location.hostname;
	return domain.includes('onsemi.cn') ? 'onsemi.cn' : 'onsemi.com';
};

export const alloyConfig = () => {
	const env = getEnvironemnt();
	if (env === 'UAT') {
		return {
			edgeConfigId: '3974fcd7-a236-4cf0-b166-468cd5911950',
			orgId: 'B46927F363E9FD120A495F99@AdobeOrg',
			debugEnabled: false
		};
	}
	return {
		edgeConfigId: '60bfd8fb-ce69-4173-a377-1c13f7260182',
		orgId: 'B46927F363E9FD120A495F99@AdobeOrg',
		debugEnabled: false
	};
};
